import Card from "./Card.jsx";
import { BallRow } from "../Ball.jsx";
import { rowsToArr } from "../../lib/lotto.js";

export default function Overview({ rows, lastDraw }) {
  const recent = rowsToArr(rows.slice(-5));
  return (
    <Card title="최근 회차" subtitle={`총 ${rows.length} 회차`} span={1}>
      {recent
        .slice()
        .reverse()
        .map((nums, i) => (
          <BallRow
            key={i}
            nums={nums}
            label={`#${lastDraw - i}`}
          />
        ))}
    </Card>
  );
}
